import React, { memo } from 'react';
import Lozenge from '@atlaskit/lozenge';
import type { Props } from './types.tsx';

const UNDEFINED = 'UNDEFINED' as const;
const TODO = 'TODO' as const;
const IN_PROGRESS = 'IN_PROGRESS' as const;
const DONE = 'DONE' as const;

const statusCategoryToAppearanceMap = {
	[UNDEFINED]: 'default',
	[TODO]: 'default',
	[DONE]: 'success',
	[IN_PROGRESS]: 'inprogress',
} as const;

const StatusLozenge = memo<Props>(({ category, name, isActive = false, isFullWidth }: Props) => {
	return (
		<Lozenge
			isBold={isActive}
			appearance={statusCategoryToAppearanceMap[category]}
			maxWidth={isFullWidth ? '100%' : undefined}
		>
			{name}
		</Lozenge>
	);
});

export default StatusLozenge;
